<script>
/**
 * There are some pieces of data that should be in the store but there are no api endpoints to retrieve them.
 * So this is a hacky component to accept the info from blade and dispatch actions to the store
 */

import { mapActions } from 'vuex';

export default {
    name: 'InitStore',
    props: {
        userAvatar: {
            type: String,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        userFirstName: {
            type: String,
            required: true,
        },
        userLastName: {
            type: String,
            required: true,
        },
    },
    methods: {
        ...mapActions(['setUser']),
    },
    mounted() {
        this.setUser({
            id: this.userId,
            avatar: this.userAvatar != 'NULL' ? this.userAvatar : '/images/frontent/deafult-avatar.png',
            firstName: this.userFirstName,
            lastName: this.userLastName,
            fullName: `${this.userFirstName} ${this.userLastName}`,
        });
    },
    render() {
        return null;
    },
};
</script>
